import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Address from './Address'
import Phone from './Phone'
import Email from './Email'
import DatePickers from './DatePicker'
import FileUpload from './FileUpload'

const EmployeeInformationForm = () => {
    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم اطلاعات کارمند'} subHeader={''} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <Heading header={'اطلاعات شخصی'} subHeader={''} />
                <FullName header={'نام و نام خانوادگی'} />
                <Address header={'آدرس'}/>
                <Phone header={'شماره تلفن'} />
                <Phone header={'شماره تلفن منزل'} />
                <Email header={'ایمیل'}/>
                <DatePickers header={'تولد'}/>
                <FileUpload header={'لطفا عکس خود را آپلود کنید'}/>
            </Grid>
        </Grid>
    )
}

export default EmployeeInformationForm
